import { EngineOutlineIcon } from './EngineOutlineIcon';

/**
 * author: Simran
 * id 75A5F242-D136-49B9-9DFF-25F0631743A7
 * name engine-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/engine-outline.svg
 * tags
 * - Automotive 
 */
export const MotorOutlineIcon = EngineOutlineIcon;
export default MotorOutlineIcon